import * as React from "react";
import { Drawer, type DrawerProps } from "@/components/Drawer";
import { Form } from "@/components/Form";

export interface DrawerFormProps extends Omit<DrawerProps, "children" | "footerContent"> {
  formId?: string;
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  primaryLabel?: string;
  secondaryLabel?: string;
  onCancel?: () => void;
  primaryVariant?: "default" | "primary" | "secondary" | "destructive" | "icon" | "link" | "unstyled" | "ghost";
  secondaryVariant?: "default" | "primary" | "secondary" | "destructive" | "icon" | "link" | "unstyled" | "ghost";
  children?: React.ReactNode;
}

export function DrawerForm({
  formId = "drawer-form",
  onSubmit,
  primaryLabel = "Save",
  secondaryLabel = "Cancel",
  onCancel,
  primaryVariant,
  secondaryVariant = "secondary",
  children,
  ...drawerProps
}: DrawerFormProps) {
  const handleFormSubmit = () => {
    const form = document.getElementById(formId) as HTMLFormElement;
    if (form) {
      form.requestSubmit();
    }
  };

  return (
    <Drawer
      primaryAction={{
        label: primaryLabel,
        onPress: handleFormSubmit,
        variant: primaryVariant,
      }}
      secondaryAction={
        onCancel
          ? {
              label: secondaryLabel,
              onPress: onCancel,
              variant: secondaryVariant,
            }
          : undefined
      }
      {...drawerProps}
    >
      <Form id={formId} onSubmit={onSubmit} className="mt-2">
        {children}
      </Form>
    </Drawer>
  );
}
